var map = {
	"./1.png": "yyge",
	"./10.png": "A4/w",
	"./11.png": "SNqh",
	"./2.png": "kQhT",
	"./3.png": "fP5Q",
	"./4.png": "6sLy",
	"./5.png": "Qg+Z",
	"./6.png": "XbMy",
	"./7.png": "thWW",
	"./8.png": "3cRS",
	"./9.png": "QFSM"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "WlRT";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/boxclose ^\.\/.*\.png$
// module id = WlRT
// module chunks = 1